var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { Typography, Button, Descriptions, message as antdMessage } from 'antd';
import { Permissions } from '@whatsper/texterchat-common';
import { useStore } from '../../../../store/rootStore';
import { formatDateTime } from '../../../../helpers';
import { Trans, useTranslation } from 'react-i18next';
import styles from './ChannelNotification.module.scss';
const { Text } = Typography;
const ChannelNotification = ({ notification, onResolved }) => {
    const { agentsStore, channels, timeFormat } = useStore();
    const { t, i18n } = useTranslation();
    const problem = notification.source;
    const [isLoading, setIsLoading] = useState(false);
    if (!problem) {
        return null;
    }
    const resolveProblem = () => __awaiter(void 0, void 0, void 0, function* () {
        setIsLoading(true);
        try {
            const response = yield channels.resolveChannelHealthProblem(problem._id);
            if (response.status === 200) {
                antdMessage.success(React.createElement(Trans, { i18nKey: "problemResolvedSuccessfully" }));
                onResolved();
            }
            else {
                antdMessage.error(React.createElement(Trans, { i18nKey: "failedToResolveProblem" }));
            }
        }
        catch (error) {
            console.error('Failed to resolve problem:', error);
            antdMessage.error(t('failedToResolveProblem'));
        }
        finally {
            setIsLoading(false);
        }
    });
    const { accountId, channel, createdAt, impairedFunctionality, instruction, name, severity, startedAt } = problem;
    const { send, receive, contactPhoneNumber } = impairedFunctionality || {};
    return (React.createElement("div", { className: styles.container },
        React.createElement(Descriptions, { size: "small", column: 1, layout: "vertical" },
            React.createElement(Descriptions.Item, { label: t('channel') }, t(`${channel}Channel`, { defaultValue: channel })),
            accountId && React.createElement(Descriptions.Item, { label: t('notificationAccountId') }, accountId),
            React.createElement(Descriptions.Item, { label: t('notificationSeverity') }, t(`notificationStatus.${severity}`)),
            name && (React.createElement(Descriptions.Item, { label: t('notificationCode') },
                React.createElement("span", { dir: "ltr" }, name))),
            startedAt && (React.createElement(Descriptions.Item, { label: t('startedAt') }, formatDateTime(startedAt, i18n.language, timeFormat))),
            createdAt && (React.createElement(Descriptions.Item, { label: t('createdAt') }, formatDateTime(createdAt, i18n.language, timeFormat))),
            instruction && (React.createElement(Descriptions.Item, { label: t('notificationInstruction') }, instruction)),
            Object.keys(impairedFunctionality || {}).length > 0 && (React.createElement(Descriptions.Item, { label: t('notificationAffectedFunctions') },
                send !== undefined && (React.createElement(Text, null,
                    t('notificationSendingAffected'),
                    ": ",
                    t(send ? 'yes' : 'no'),
                    React.createElement("br", null))),
                receive !== undefined && (React.createElement(Text, null,
                    t('notificationReceivingAffected'),
                    ": ",
                    t(receive ? 'yes' : 'no'),
                    React.createElement("br", null))),
                contactPhoneNumber && (React.createElement(Text, null,
                    t('phoneNumber'),
                    ": ",
                    contactPhoneNumber))))),
        agentsStore.hasPermissions([Permissions.Permission.channels_manage]) && (React.createElement("div", { className: styles.actions },
            React.createElement(Button, { type: "primary", onClick: () => {
                    void resolveProblem();
                }, loading: isLoading },
                React.createElement(Trans, { i18nKey: "resolveProblem" }))))));
};
export default observer(ChannelNotification);
